const parseQueryString = (queryString?: string) =>
  [...new URLSearchParams(queryString).entries()]
    .reduce<Record<string, string>>((accumulator, [key, value]) => ({
      ...accumulator,
      [key]: value,
    }), {});

export default parseQueryString;
